/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {
  MdErrorDirective,
  MdHint,
  MdInputContainer,
  MdInputDirective,
  MdPlaceholder,
  MdPrefix,
  MdSuffix
} from './input-container';
import {MdTextareaAutosize} from './autosize';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PlatformModule} from '../core/platform/index';
export class MdInputModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    MdErrorDirective,
    MdHint,
    MdInputContainer,
    MdInputDirective,
    MdPlaceholder,
    MdPrefix,
    MdSuffix,
    MdTextareaAutosize,
  ],
  imports: [
    CommonModule,
    FormsModule,
    PlatformModule,
  ],
  exports: [
    MdErrorDirective,
    MdHint,
    MdInputContainer,
    MdInputDirective,
    MdPlaceholder,
    MdPrefix,
    MdSuffix,
    MdTextareaAutosize,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdInputModule_tsickle_Closure_declarations() {
/** @type {?} */
MdInputModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdInputModule.ctorParameters;
}



export {MdTextareaAutosize} from './autosize';
export {MdPlaceholder,MdHint,MdErrorDirective,MdPrefix,MdSuffix,MdInputDirective,MdInputContainer} from './input-container';
export {getMdInputContainerPlaceholderConflictError,getMdInputContainerUnsupportedTypeError,getMdInputContainerDuplicatedHintError,getMdInputContainerMissingMdInputError} from './input-container-errors';


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
